import "./common.js";
import "../i18n.js";
import "../portico/header.js";
import "../portico/google-analytics.js";
import "../../styles/portico/portico-styles.scss";
